export enum CallStatusErrorCode {
    ERROR_MAKE_CALL,
    ERROR_MAKE_CALL_NOT_FOUND,
    ERROR_MAKE_CALL_MEDIA_REJECTED,
    ERROR_MAKE_CALL_BUSY,
    ERROR_MAKE_CALL_DECLINED,
    ERROR_MAKE_CALL_SERVICE_ERROR,
    ERROR_MAKE_CALL_PERMISSION,
    ERROR_ANSWER_CALL,
    ERROR_ANSWER_CALL_PERMISSION,
    ERROR_HANG_UP,
    ERROR_MIDCALL,
    ERROR_MIDCALL_PERMISSION,
    ERROR_HOLD,
    ERROR_HOLD_PERMISSION,
    ERROR_RESUME,
    ERROR_RESUME_PERMISSION,
    ERROR_TRANSFER,
    ERROR_SCREEN_RECORDING,
    ERROR_QUEUE_HOLD,
    ERROR_QUEUE_HOLD_FOR,
    ERROR_QUEUE_RESUME,
    ERROR_SEND_TO_VOICEMAIL,
    ERROR_DECLINE_BUSY,
}
